define( function() {
	"use strict";

	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/jquery/src/ajax/var/location.js
// module id = 939
// module chunks = 1